class ProductForm extends HTMLElement {
    constructor() {
        super();   

        this.form = this.querySelector('form');
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.cartNotification && typeof this.cartNotification.setActiveElement === 'function') {
            this.cartNotification.setActiveElement(document.activeElement);
        }
    
        const submitButton = this.querySelector('[type="submit"]');

        submitButton.setAttribute('disabled', true);
        submitButton.classList.add('loading');

        const payload = {
            ...JSON.parse(serializeForm(this.form))
        };

        if (this.cartNotification && typeof this.cartNotification.getSectionsToRender === 'function') {
            payload.sections = this.cartNotification.getSectionsToRender().map((section) => section.id);
            payload.sections_url = window.location.pathname;
        }

        const body = JSON.stringify(payload);

        fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
        .then((response) => response.json())
        .then((parsedState) => {
            const haloCartSidebar = document.querySelector('#halo-cart-sidebar');

            if (haloCartSidebar) {
                document.body.classList.add('cart-sidebar-show');

                if (
                    window.Shopify &&
                    typeof window.Shopify.getCart === 'function' &&
                    window.sharedFunctions &&
                    typeof window.sharedFunctions.updateSidebarCart === 'function'
                ) {
                    window.Shopify.getCart((cart) => {
                        window.sharedFunctions.updateSidebarCart(cart);
                    });
                }

                return;
            }

            if (this.cartNotification && typeof this.cartNotification.renderContents === 'function') {
                this.cartNotification.renderContents(parsedState);
                return;
            }
        })
        .catch((e) => {
            console.error(e);
        })
        .finally(() => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('disabled');
        });
    }
}

customElements.define('product-form', ProductForm);
